import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './App.css';
import '../scss/App.scss';
import asyncComponent from '../components/AsyncComponent';
//import * as profileActions from '../actions/profile';
import AnonymousNavbar from '../components/anonymousnavbar';
import NotFound404 from '../components/NotFound404';
import { isIframe, removeQueryStringParams } from '../components/utils';
import base64 from 'base-64';
import utf8 from 'utf8';

import NotificationSystem from 'react-notification-system';

import * as sessionActions from '../actions/session';

const Navbar = asyncComponent(() => import ('../components/navbar'));
const AsyncLoginPage = asyncComponent(() => import("../containers/LoginPage"));
const AsyncLandingPage = asyncComponent(() => import("../containers/LandingPage"));
const AsyncAgentProfile = asyncComponent(() => import("../containers/AgentProfile"));
const AsyncCorrespondenceMobile = asyncComponent(() => import("../containers/CorrespondenceMobile"));
const AsyncRecommendedServices = asyncComponent(() => import("../containers/RecommendedServicesMobile"));
const AsyncDashboardPage = asyncComponent(() => import("../containers/DashboardPage"));
const AsyncActivityFeedIframePage = asyncComponent(() => import("../containers/ActivityFeedIframe"));
const AsyncMyListings = asyncComponent(() => import("../containers/MyListingsPage"));
const AsyncMyListingsFiltered = asyncComponent(() => import("../containers/MyListingsPageFiltered"));
const AsyncListingDetails = asyncComponent(() => import("../containers/ListingDetailsPage"));
const AsyncCorrespondence = asyncComponent(() => import("../containers/CorrespondencePage"));
const AsyncSearchPage = asyncComponent(() => import("../containers/SearchPage"));
const AsyncApplicationInsights = asyncComponent(() => import("../components/ApplicationInsights"));
const AsyncGoogleAnalytics = asyncComponent(() => import("../components/GoogleAnalytics"));

class App extends Component {

  // constructor(props) {
  //   super(props);
  // }

  showNotification = (type, title, message, duration, button1Text, button1Function, button1FunctionParam, button2Text, button2Function,button2FunctionParam) => {
      if(this.notificationSystem) {
          var nProps = {
              message: message,
              level: type,
              autoDismiss: 8,
              dismissible: true,
              position: 'tc'
          };
          if(title && title !== ''){
              nProps.title = title;
          }
          if(button1Text || button2Text){
              var btn1 = null;
              if(button1Text && button1Function && button1FunctionParam){
                  btn1 = <button className="btn btn-default" onClick={() => button1Function(button1FunctionParam)}>{button1Text}</button>
              }
              else if(button1Text && button1Function && !button1FunctionParam){
                  btn1 = <button className="btn btn-default" onClick={button1Function}>{button1Text}</button>
              }
              else if(button1Text && !button1Function){
                  btn1 = <button className="btn btn-default">{button1Text}</button>
              }
              var btn2 = null;
              if(button2Text && button2Function && button2FunctionParam){
                  btn2 = <button className="btn btn-default" onClick={() => button2Function(button2FunctionParam)}>{button2Text}</button>
              }
              else if(button2Text && button2Function && !button2FunctionParam){
                  btn2 = <button className="btn btn-default" onClick={button2Function}>{button2Text}</button>
              }
              else if(button2Text && !button2Function){
                  btn2 = <button className="btn btn-default">{button2Text}</button>
              }
              var child = (<div className="notification_btn">{btn1} {btn2}</div>);
              nProps.children = child;
              nProps.autoDismiss = 0;
          }

          this.notificationSystem.clearNotifications();
          this.notificationSystem.addNotification(nProps);
      }
  }

  render() {
    const { session } = this.props;

    var nsStyle = {
      NotificationItem: {
        DefaultStyle: {
          margin: "0",
          width: "100%",
          left: "0"
        },     
        success: {
          margin: '0',
          width: "100%",
          backgroundColor: "#E2FDD6",
          color: "#006644",
          borderBottom: "2px solid rgb(94, 164, 0)"
        }
      }
    }
   
    return (
      <div className="App">
        <Router>
          <div>
            <NotificationSystem ref={(ref) => this.notificationSystem = ref} style={nsStyle} />
            
            <Switch>
              <Route path="/login" render={(props) =>
                  <AsyncLoginPage showNotification={this.showNotification} { ...props } />}/>

              {/* Private Routes that Require Login */}
              <PrivateRoute 
                path="/iframe/activity" 
                exact={true} 
                session={ session }
                component={AsyncActivityFeedIframePage}
                showNotification={this.showNotification}
                />

              <PrivateRoute 
                path="/dashboard" 
                exact={true} 
                session={ session }
                component={AsyncDashboardPage}
                showNotification={this.showNotification}
                />
              <PrivateRoute 
                path="/agent-profile" 
                exact={true} 
                session={ session }
                component={AsyncAgentProfile}
                showNotification={this.showNotification}
                />
              <PrivateRoute 
                path="/correspondance-mobile" 
                exact={true} 
                session={ session }
                component={AsyncCorrespondenceMobile}
                showNotification={this.showNotification}
                />
              <PrivateRoute 
                path="/recommended-services" 
                exact={true} 
                session={ session }
                component={AsyncRecommendedServices}
                showNotification={this.showNotification}
                />
              <PrivateRoute 
                path="/my-listings" 
                exact={true} 
                session={ session }
                component={AsyncMyListings}
                showNotification={this.showNotification}
                />
              <PrivateRoute 
                path="/listing-details/:listingId" 
                exact={true} 
                session={ session }
                component={AsyncListingDetails}
                showNotification={this.showNotification}
                />
              <PrivateRoute 
                path="/my-listings-type/:type/:receivedDate?"
                exact={true} 
                session={ session }
                component={AsyncMyListingsFiltered}
                showNotification={this.showNotification}
                />
              <PrivateRoute 
                path="/correspondence/:type"
                exact={true} 
                session={ session }
                component={AsyncCorrespondence}
                showNotification={this.showNotification}
                />
              <PrivateRoute 
                path="/search/:filters?"
                exact={true} 
                session={ session }
                component={AsyncSearchPage}
                showNotification={this.showNotification}
                />
              <PrivateRoute 
                path="/" 
                exact={true} 
                session={ session }
                component={AsyncLandingPage}
                showNotification={this.showNotification}
                />
              <Route render={(props) =>
                  <NotFound404 showNotification={this.showNotification} { ...props } />}/>
              </Switch>
              <AsyncGoogleAnalytics />
              <AsyncApplicationInsights />
            </div>
          </Router>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {

  // const { entities, clients, activity } = state;
  // const selectedClient = entities.clients[clients.selectedClient];

  // let feedActivity;
  // if (selectedClient) {
  //     feedActivity = activity[selectedClient.Id];
  // }
  // else {
  //     feedActivity = activity['mine'];
  // }

  return {
      //audience: state.session.audience,
      session: state.session,
      //sessionNotification: state.session.notificationMessage,
      //feedItems: state.entities.feedItems,
      //selectedClient,        
      //feedActivity,
      //feedActivityEntities: state.entities.activities,
      //isAnonymous: state.profile.isAnonymous,
  }
};

const mapDispatchToProps = dispatch => ({
  sessionActions: bindActionCreators(sessionActions, dispatch),
  //feedActions: bindActionCreators(feedActions, dispatch),
  //activityActions: bindActionCreators(activityActions, dispatch),
  //listingActions: bindActionCreators(listingActions, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(App);

// Redirect to the component only if the user is logged in, otherwise send to login page
const PrivateRoute = ({component: Component, session, refreshAuth, ...rest }) => (
  <Route {...rest} render={props => {
      const { isAuthenticating, isAuthenticated } = session;
 
      // We are not Authenticated and there is no open Authentication requests
      // Redirect to login
      if (isAuthenticated === false && isAuthenticating === false) {

          if(props.location && props.location.pathname && props.location.pathname !== '/' && props.location.pathname !== '/profile'){

              var redirectToUrl = removeQueryStringParams("token");
              window.sessionStorage.setItem("RedirectLocation",base64.encode(utf8.encode(redirectToUrl)));
          }
          
          // Push with query string so user will login
          props.history.push(`/login${props.location.search}`);
          return null;
      }

      // Waiting on Authentication to complete so display a message
      if (isAuthenticating && isAuthenticated === false) {
            return null;
            //<PendingAuthentication />;
      }

      // Return the secure page and the navbar
      return <div>
              {(!isIframe() && session.isAuthenticated ) ?
                <Navbar showNotification={rest.showNotification} /> : <AnonymousNavbar/>}
              <Component {...props} {...rest} />
            </div>;

  }}/>
)